module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"startingSoon":"Es ist bald soweit…","requestInvitationCode":"Einladungscode anfordern","request":"Anfordern","email":"E-Mail-Adresse","orderPeriod":"Bestellzeitraum: {start} bis {end}"},"en":{"startingSoon":"Starting soon…","requestInvitationCode":"Request invitation code","request":"Request","email":"Email","orderPeriod":"Order period: {start} to {end}"}}')
  delete Component.options._Ctor
}
